export const DISCOUNT_CODES = ['SAFETYBYCILIA'] as const;

export const DISCOUNT_CODES_BY_DISCOUNT: Record<
  number,
  (typeof DISCOUNT_CODES)[number]
> = {
  40: 'SAFETYBYCILIA'
};
